import { floatAnimations, orbAnimations } from './animations';

export const seededRandom = (seed: number): number => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

export type BubbleData = {
  id: number;
  size: number;
  left: number;
  bottom: number;
  delay: number;
  duration: number;
  animIndex: number;
  hue: number;
};

export type OrbData = {
  id: number;
  size: number;
  left: number;
  top: number;
  delay: number;
  duration: number;
  animIndex: number;
  hue: number;
};

export const generateBubbles = (seed: string): BubbleData[] => {
  const seedNum = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const bubbleCount = 20 + Math.floor(seededRandom(seedNum) * 15);

  return Array.from({ length: bubbleCount }, (_, i) => {
    const s = seedNum + i * 7;
    return {
      id: i,
      size: 30 + seededRandom(s) * 70,
      left: seededRandom(s + 1) * 100,
      bottom: -10 + seededRandom(s + 2) * 40,
      delay: seededRandom(s + 3) * 8,
      duration: 8 + seededRandom(s + 4) * 12,
      animIndex: Math.floor(seededRandom(s + 5) * floatAnimations.length),
      hue: 155 + seededRandom(s + 6) * 35,
    };
  });
};

export const generateOrbs = (seed: string): OrbData[] => {
  const seedNum = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const orbCount = 8 + Math.floor(seededRandom(seedNum + 100) * 4);

  return Array.from({ length: orbCount }, (_, i) => {
    const s = seedNum + i * 13 + 200;
    return {
      id: i,
      size: 150 + seededRandom(s) * 300,
      left: -10 + seededRandom(s + 1) * 120,
      top: -10 + seededRandom(s + 2) * 120,
      delay: seededRandom(s + 3) * 4,
      duration: 5 + seededRandom(s + 4) * 8,
      animIndex: Math.floor(seededRandom(s + 5) * orbAnimations.length),
      hue: 155 + seededRandom(s + 6) * 40,
    };
  });
};
